(function (_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_datetime, kotlin_com_russhwolf_multiplatform_settings_no_arg, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a2;
  var objectMeta = kotlin_kotlin.$_$.y9;
  var InstantIso8601Serializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_datetime.$_$.a;
  var Unit_getInstance = kotlin_kotlin.$_$.k4;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d;
  var THROW_CCE = kotlin_kotlin.$_$.vc;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x1;
  var classMeta = kotlin_kotlin.$_$.v8;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
  var System_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_datetime.$_$.b;
  var hashCode = kotlin_kotlin.$_$.d9;
  var equals = kotlin_kotlin.$_$.x8;
  var Companion_getInstance = kotlin_kotlin.$_$.c4;
  var DurationUnit_MILLISECONDS_getInstance = kotlin_kotlin.$_$.g;
  var toDuration = kotlin_kotlin.$_$.ec;
  var interfaceMeta = kotlin_kotlin.$_$.e9;
  var Settings = kotlin_com_russhwolf_multiplatform_settings_no_arg.$_$.a;
  var toString = kotlin_kotlin.$_$.sd;
  var Json$default = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.h1;
  //endregion
  //region block: pre-declaration
  function getContentOrNullIfExpired(value) {
    var tmp;
    if (value.m4z()) {
      tmp = null;
    } else {
      tmp = value.k4z_1;
    }
    return tmp;
  }
  function calculateExpiryTime() {
    var tmp = System_getInstance().r4y();
    var tmp$ret$0;
    // Inline function 'kotlin.time.Companion.milliseconds' call
    var tmp0__get_milliseconds__kazo1t = Companion_getInstance();
    var tmp1__get_milliseconds__r2e6ua = this.n4z();
    tmp$ret$0 = toDuration(tmp1__get_milliseconds__r2e6ua, DurationUnit_MILLISECONDS_getInstance());
    return tmp.z4y(tmp$ret$0);
  }
  function get(key) {
    var tmp1_elvis_lhs = this.q4z().s4z(key);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp0_safe_receiver = this.r4z().s4z(key);
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        var tmp$ret$0;
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.taager.experience.cache.LocalCacheStrategy.get.<anonymous>' call
        this.q4z().y4z(key, tmp0_safe_receiver);
        tmp$ret$0 = tmp0_safe_receiver;
        tmp_0 = tmp$ret$0;
      }
      tmp = tmp_0;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function set(key, content) {
    this.q4z().y4z(key, content);
    this.r4z().y4z(key, content);
  }
  //endregion
  function $serializer_init_$Init$(typeSerial0, $this) {
    $serializer.call($this);
    $this.g4z_1 = typeSerial0;
    return $this;
  }
  function $serializer_init_$Create$(typeSerial0) {
    return $serializer_init_$Init$(typeSerial0, Object.create($serializer.prototype));
  }
  function Companion() {
    Companion_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.taager.experience.cache.LocalCache.Value', null, 2);
    tmp0_serialDesc.s2n('content', false);
    tmp0_serialDesc.s2n('expiryTime', false);
    Companion_getInstance_0().h4z_1 = tmp0_serialDesc;
  }
  Companion.prototype.i4z = function (typeSerial0) {
    return $serializer_init_$Create$(typeSerial0);
  };
  Companion.prototype.o2o = function (typeParamsSerializers) {
    return this.i4z(typeParamsSerializers[0]);
  };
  Companion.$metadata$ = objectMeta('Companion', [SerializerFactory]);
  var Companion_instance;
  function Companion_getInstance_0() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function $serializer() {
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.taager.experience.cache.LocalCache.Value', this, 2);
    tmp0_serialDesc.s2n('content', false);
    tmp0_serialDesc.s2n('expiryTime', false);
    this.f4z_1 = tmp0_serialDesc;
  }
  $serializer.prototype.g2e = function () {
    return this.f4z_1;
  };
  $serializer.prototype.u2n = function () {
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp0_arrayOf = [this.g4z_1, InstantIso8601Serializer_getInstance()];
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_arrayOf;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  };
  $serializer.prototype.i2e = function (decoder) {
    var tmp0_desc = this.f4z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.c2h(tmp0_desc);
    if (tmp6_input.p2h()) {
      tmp4_local0 = tmp6_input.n2h(tmp0_desc, 0, this.g4z_1, tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.n2h(tmp0_desc, 1, InstantIso8601Serializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.q2h(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.n2h(tmp0_desc, 0, this.g4z_1, tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.n2h(tmp0_desc, 1, InstantIso8601Serializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.d2h(tmp0_desc);
    return Value_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  $serializer.prototype.j4z = function (encoder, value) {
    var tmp0_desc = this.f4z_1;
    var tmp1_output = encoder.c2h(tmp0_desc);
    tmp1_output.o2i(tmp0_desc, 0, this.g4z_1, value.k4z_1);
    tmp1_output.o2i(tmp0_desc, 1, InstantIso8601Serializer_getInstance(), value.l4z_1);
    tmp1_output.d2h(tmp0_desc);
  };
  $serializer.prototype.h2e = function (encoder, value) {
    return this.j4z(encoder, value instanceof Value ? value : THROW_CCE());
  };
  $serializer.prototype.v2n = function () {
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = [this.g4z_1];
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  };
  $serializer.$metadata$ = classMeta('$serializer', [GeneratedSerializer]);
  function Value_init_$Init$(seen1, content, expiryTime, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, Companion_getInstance_0().h4z_1);
    }
    $this.k4z_1 = content;
    $this.l4z_1 = expiryTime;
    return $this;
  }
  function Value_init_$Create$(seen1, content, expiryTime, serializationConstructorMarker) {
    return Value_init_$Init$(seen1, content, expiryTime, serializationConstructorMarker, Object.create(Value.prototype));
  }
  function Value(content, expiryTime) {
    Companion_getInstance_0();
    this.k4z_1 = content;
    this.l4z_1 = expiryTime;
  }
  Value.prototype.m4z = function () {
    return this.l4z_1.b4z(System_getInstance().r4y()) < 0;
  };
  Value.prototype.toString = function () {
    return 'Value(content=' + this.k4z_1 + ', expiryTime=' + this.l4z_1 + ')';
  };
  Value.prototype.hashCode = function () {
    var result = this.k4z_1 == null ? 0 : hashCode(this.k4z_1);
    result = imul(result, 31) + this.l4z_1.hashCode() | 0;
    return result;
  };
  Value.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Value))
      return false;
    var tmp0_other_with_cast = other instanceof Value ? other : THROW_CCE();
    if (!equals(this.k4z_1, tmp0_other_with_cast.k4z_1))
      return false;
    if (!this.l4z_1.equals(tmp0_other_with_cast.l4z_1))
      return false;
    return true;
  };
  Value.$metadata$ = classMeta('Value', undefined, undefined, {0: Companion_getInstance_0});
  function LocalCache() {
  }
  LocalCache.$metadata$ = interfaceMeta('LocalCache');
  function ifNull(_this__u8e3s4, block) {
    if (_this__u8e3s4 == null) {
      block();
    }
    return _this__u8e3s4;
  }
  function LocalCacheStrategy() {
  }
  LocalCacheStrategy.$metadata$ = interfaceMeta('LocalCacheStrategy');
  function get_jsonParser() {
    init_properties_DiskCache_kt_4mmzv5();
    return jsonParser;
  }
  var jsonParser;
  function decode(_this__u8e3s4, $this) {
    return get_jsonParser().z2e(Companion_getInstance_0().i4z($this.w4z_1), _this__u8e3s4);
  }
  function encode(_this__u8e3s4, $this) {
    return get_jsonParser().y2e(Companion_getInstance_0().i4z($this.w4z_1), _this__u8e3s4);
  }
  function DiskCache$get$lambda(this$0, $settingsKey) {
    return function () {
      this$0.x4z_1.g1u($settingsKey);
      return Unit_getInstance();
    };
  }
  function DiskCache(maxAgeInMilliseconds, serializer) {
    this.v4z_1 = maxAgeInMilliseconds;
    this.w4z_1 = serializer;
    this.x4z_1 = Settings();
  }
  DiskCache.prototype.n4z = function () {
    return this.v4z_1;
  };
  DiskCache.prototype.s4z = function (key) {
    var settingsKey = toString(key);
    var tmp0_safe_receiver = this.x4z_1.d4z(settingsKey);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp$ret$1;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$0;
      // Inline function 'com.taager.experience.cache.disk.DiskCache.get.<anonymous>' call
      var tmp_0 = this.o4z(decode(tmp0_safe_receiver, this));
      tmp$ret$0 = ifNull(tmp_0, DiskCache$get$lambda(this, settingsKey));
      tmp$ret$1 = tmp$ret$0;
      tmp = tmp$ret$1;
    }
    return tmp;
  };
  DiskCache.prototype.y4z = function (key, content) {
    var value = new Value(content, this.p4z());
    this.x4z_1.c4z(toString(key), encode(value, this));
  };
  DiskCache.$metadata$ = classMeta('DiskCache', [LocalCache]);
  function jsonParser$lambda($this$Json) {
    init_properties_DiskCache_kt_4mmzv5();
    $this$Json.v2x_1 = true;
    $this$Json.x2x_1 = true;
    $this$Json.y2x_1 = true;
    return Unit_getInstance();
  }
  var properties_initialized_DiskCache_kt_c6fux7;
  function init_properties_DiskCache_kt_4mmzv5() {
    if (properties_initialized_DiskCache_kt_c6fux7) {
    } else {
      properties_initialized_DiskCache_kt_c6fux7 = true;
      jsonParser = Json$default(null, jsonParser$lambda, 1, null);
    }
  }
  function MemoryCache$get$lambda(this$0, $key) {
    return function () {
      this$0.u4z_1.nc($key);
      return Unit_getInstance();
    };
  }
  function MemoryCache(maxAgeInMilliseconds) {
    this.t4z_1 = maxAgeInMilliseconds;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap_init_$Create$();
    tmp.u4z_1 = tmp$ret$0;
  }
  MemoryCache.prototype.n4z = function () {
    return this.t4z_1;
  };
  MemoryCache.prototype.s4z = function (key) {
    var tmp0_safe_receiver = this.u4z_1.p(key);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp$ret$1;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$0;
      // Inline function 'com.taager.experience.cache.memory.MemoryCache.get.<anonymous>' call
      var tmp_0 = this.o4z(tmp0_safe_receiver);
      tmp$ret$0 = ifNull(tmp_0, MemoryCache$get$lambda(this, key));
      tmp$ret$1 = tmp$ret$0;
      tmp = tmp$ret$1;
    }
    return tmp;
  };
  MemoryCache.prototype.y4z = function (key, content) {
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = this.u4z_1;
    var tmp1_set = new Value(content, this.p4z());
    tmp0_set.a(key, tmp1_set);
  };
  MemoryCache.$metadata$ = classMeta('MemoryCache', [LocalCache]);
  //region block: post-declaration
  DiskCache.prototype.o4z = getContentOrNullIfExpired;
  DiskCache.prototype.p4z = calculateExpiryTime;
  MemoryCache.prototype.o4z = getContentOrNullIfExpired;
  MemoryCache.prototype.p4z = calculateExpiryTime;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = DiskCache;
  _.$_$.b = MemoryCache;
  _.$_$.c = get;
  _.$_$.d = set;
  _.$_$.e = LocalCacheStrategy;
  //endregion
  return _;
}(module.exports, require('./kotlinx-serialization-kotlinx-serialization-core-js-ir.js'), require('./kotlin-kotlin-stdlib-js-ir.js'), require('./Kotlin-DateTime-library-kotlinx-datetime-js-ir.js'), require('./MultiplatformSettings-multiplatform-settings-no-arg-js-ir.js'), require('./kotlinx-serialization-kotlinx-serialization-json-js-ir.js')));

